import { render, staticRenderFns } from "./EditGiftForList.vue?vue&type=template&id=3481d75a&scoped=true&"
import script from "./EditGiftForList.ts?vue&type=script&lang=ts&"
export * from "./EditGiftForList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481d75a",
  null
  
)

export default component.exports